import { memo, useCallback, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJActionVideoRemoveBg from '../../../../redux/action/FJActionVideoRemoveBg';
import FJPlayController from '../../../../common/components/FJVideoPlayer/playController/FJController';
import PropTypes from 'prop-types';
import FJEvent from '../../../../store/FJEvent';
import { FJ_EVENT_TYPE } from '../../../../constants/FJEvenTypeConstant';

const FJVideoRemoveBgAfterControlsContainer = memo(({ fullScreenClick, isFullScreen, disabled }) => {
    useLocalStore();
    const dispatch = useDispatch();

    const totalTime = useSelector(state => state.videoBgRemover.totalTime);
    const currentTime = useSelector(state => state.videoBgRemover.currentTime);
    const isPlaying = useSelector(state => state.videoBgRemover.isPlaying);

    const playCrlEle = useRef(null);

    useEffect(() => {
        if (playCrlEle.current) {
            const progress = Math.min(currentTime / totalTime, 1);
            playCrlEle.current.updateProgress(progress);
        }
    }, [currentTime, totalTime]);

    useEffect(() => {
        if (playCrlEle.current) {
            playCrlEle.current.changePlayState(isPlaying);
        }
    }, [isPlaying]);

    const _seekVideo = useCallback(
        data => {
            if (disabled) return;
            FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
            const time = totalTime * data;
            dispatch(FJActionVideoRemoveBg.seekAction(time));
        },
        [totalTime, dispatch, disabled],
    );

    const _play = useCallback(() => {
        if (disabled) return;
        FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
        dispatch(FJActionVideoRemoveBg.playAction());
    }, [dispatch, disabled]);

    const _pause = useCallback(() => {
        if (disabled) return;
        FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
        dispatch(FJActionVideoRemoveBg.pauseAction());
    }, [dispatch, disabled]);

    const _volumeChange = useCallback(
        data => {
            if (disabled) return;
            FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
            dispatch(FJActionVideoRemoveBg.setVolumeAction(data));
        },
        [dispatch, disabled],
    );

    return (
        <FJPlayController
            ref={playCrlEle}
            duration={totalTime}
            currentTime={currentTime}
            dataChange={_seekVideo}
            play={_play}
            pause={_pause}
            isKeySpace={true}
            previewVolumeChange={_volumeChange}
            isShowVolume={true}
            isShowFullScreen={true}
            isShowPlayBtn={false}
            isFullScreen={isFullScreen}
            fullScreenClick={fullScreenClick}
            disabled={disabled}
            scope='default'
        />
    );
});

FJVideoRemoveBgAfterControlsContainer.propTypes = {
    fullScreenClick: PropTypes.func,
    isFullScreen: PropTypes.bool,
    disabled: PropTypes.bool,
};

FJVideoRemoveBgAfterControlsContainer.displayName = 'FJVideoRemoveBgAfterControlsContainer';
export default FJVideoRemoveBgAfterControlsContainer;
